import { useAdminAuth } from "@auth/AuthContext"
import type { ReactNode } from "react"
import { Navigate, useLocation } from "react-router-dom"

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated } = useAdminAuth()
  const location = useLocation()
  if (isAuthenticated) return <>{children}</>
  // A deep link from an email or a chat (the superuser's usual entrance)
  // survives the login: Login reads `state.from` and returns there.
  return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />
}
